<template>
  <div class="commonTable-container">
    <!-- v-loading="columObj.loading" -->
    <el-table
    ref="multipleTable"
      size="medium"
      :data="tableData"
      :stripe="false"
      :border="false"
      :fit="true"
      :show-header="true"
      :highlight-current-row="false"
      :row-class-name="tableRowClassName"
      :row-key="columObj.rowKey || 'id'"
      :tree-props="columObj.treeProps || { children: 'children', hasChildren: 'hasChildren' }"
      :lazy="columObj.lazy || false"
      :load="columObj.load"
      @row-click="rowClick"
      @select="selectChange"
       @selection-change="handleSelectionChange"
       @cell-dblclick="rowOperation"
    >
      <!-- 选择框是否开启，selectable控制是否单行禁用 -->
      <el-table-column
        v-if="columObj.selection"
        type="selection"
        :selectable="columObj.selectable"
      >
      </el-table-column>
      <!-- 索引列 -->
      <el-table-column
        v-if="columObj.index"
        type="index"
        label="序号"
        width="60"
        align="center"
      >
      </el-table-column>
      <!-- 普通列 -->
      <el-table-column
        v-for="(column, columIndex) in columObj.columnData"
        :key="columIndex"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :fixed="column.fixed"
        :align="column.align || 'center'"
        :sortable="column.sortable"
        :index="columIndex"
        show-overflow-tooltip
      >
        <template slot-scope="{ row, $index }">
          <!-- 默认展示 -->
          <span v-if="!column.ownDefined && !column.switch && !column.image && !column.status && !column.isOperation">{{
            row[column.prop]
          }}</span>
          <!-- 状态对象展示 -->
          <span v-if="column.status && row[column.prop]">{{
            row[column.prop].msg
          }}</span>
          <!-- 自定义内容 -->
          <span v-if="column.ownDefined">
            <template v-if="column.type === 'slot'">
              <slot :name="column.prop" :row="row" :index="$index"></slot>
            </template>
            <template v-else>
              {{ column.ownDefinedReturn(row, $index) }}
            </template>
          </span>
          <!-- switch开关 -->
          <el-switch
            v-if="column.switch"
            v-model="row[column.prop]"
            :inactive-text="
              row[column.prop] ? column.openText : column.closeText
            "
            @change="switchChange(row, $index, column.prop)"
          ></el-switch>
          <!-- 图片展示 -->
          <el-popover trigger="hover" placement="top" popper-class="popper">
            <img v-if="column.image" :src="viewUrl + row[column.prop]" />
            <el-image
              slot="reference"
              v-if="column.image"
              :src="viewUrl + row[column.prop]"
            ></el-image>
          </el-popover>
          <!-- 可编辑input，仅在text默认展示类型才可编辑-->
          <el-input
            v-focus
            v-if="column.editRow == $index && column.text"
            v-model="row[column.prop]"
            @blur="editInputBlur(row, $index, column.prop, columIndex)"
          ></el-input>
          <!-- 操作按钮 -->
          <template v-if="column.isOperation">
            <div class="operation-btns">
              <span v-for="(operations, index) in column.operation" :key="index">
                <el-button
                  v-if="!operations.isShow || operations.isShow(row, index)"
                  :icon="operations.icon"
                  :type="operations.type"
                  @click="operations.buttonClick ? operations.buttonClick(row, index, operations.operation) : rowOperation(row, index, operations.operation)"
                  :style="{ color: operations.color }"
                  size="small"
                  >{{ operations.label }}</el-button
                >
              </span>
            </div>
          </template>
        </template>
      </el-table-column>
      <!-- 操作列 -->
      <el-table-column
        v-if="columObj.operate && columObj.operate.length > 0"
        label="操作"
        width="200"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row, $index }">
          <div class="operation-btns">
            <span v-for="(operation, index) in columObj.operate" :key="index">
              <el-button
                :type="operation.type"
                :size="operation.size || 'mini'"
                :icon="operation.icon"
                @click="rowOperation(row, operation.handle)"
              >{{ operation.label }}</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页
    <div class="page_div" :style="{ textAlign: pageObj.position || 'center' }">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :current-page="pageObj.pageData.page"
        :pager-count="7"
        :page-sizes="[10, 15, 20, 30, 50]"
        :page-size="pageObj.pageData.size"
        background
        layout="total,sizes,prev, pager, next"
        :total="pageObj.total"
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'CommonTable',
  directives: {
    // 自定义指令,用于可编辑input自动获取焦点
    focus: {
      inserted: function (e) {
        e.querySelector('input').focus()
      }
    }
  },
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columObj: {
      type: Object,
      required: true
    }
   
  },
  data() {
    // let readUploadFileUrl = this.$store.state.user.readUploadFileUr
    return {
      // viewUrl: readUploadFileUr
    }
  },
  methods: {
    // 行操作
    rowOperation(row, param2, param3) {
      console.log(row, param2, param3, 'canshu');
      
      // 兼容两种调用方式：
      // 1. operate列调用: rowOperation(row, handle) - 2个参数
      // 2. columnData.operation调用: rowOperation(row, index, type) - 3个参数
      
      let type, index
      
      if (param3 === undefined) {
        // 2参数调用 (来自operate列)
        type = param2  // 'edit', 'delete' 等
        index = 0
      } else {
        // 3参数调用 (来自columnData.operation)
        index = param2  // 数字索引
        type = param3   // 'edit', 'delete' 等
      }
      
      this.$emit('rowOperation', row, index, type)
    },
    switchChange(row, $index, prop) {
      this.$emit('switchChange', row, $index, prop)
    },
    // 帮助点击行，获取点击的下标
    tableRowClassName({ row, rowIndex }) {
      row.rowIndex = rowIndex
      return row.switch ? 'selected-row' : ''
    },
    // 点击行
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event)
      if (event.type === 'click' && column.type !== 'selection') {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    editInputBlur(row, $index, prop, columIndex) {
      this.$emit('editInputBlur', row, $index, prop, columIndex)
    },
    // 测试
    selectChange(selection, row) {
      this.$emit('selectChange',selection, row)
    },
    handleSelectionChange(selection, row) {
      this.tableData.forEach(item => {
        const isSelected = selection.some(selectedRow => selectedRow.id === item.id)
        item.switch = isSelected
      })
      this.$emit('selectionChange', selection, row)
    }
    // // 条数变化
    // handleSizeChange(e) {
    //   this.$emit('handleSizeChange', e)
    // },
    // // 页码变化
    // handleCurrentChange(e) {
    //   this.$emit('handleCurrentChange', e)
    // }
  }
}
</script>
<style lang="scss" scoped>
.operation-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}


::v-deep .el-table__row:hover {
  background-color: #f5f7fa !important;
}

::v-deep .el-table__row.selected-row {
  background-color: #ecf5ff !important;
  
  &:hover {
    background-color: #ecf5ff !important;
  }
  
  
  & td {
    background-color: #ecf5ff !important;
  }
}

::v-deep .el-table__row--highlight {
  background-color: transparent !important;
}

::v-deep .el-table__row.selected-row td {
  background-color: #ecf5ff !important;
}

::v-deep .el-table__row {
  transition: background-color 0.2s ease;
}
</style>